import { useFormController } from '@dreryk/react-common';

import { MedicineRawMaterialTableBean } from '../../../shared/formFields/magistralDrug/medicineRawMaterials/MedicineRawMaterialTable.types';

import { MagistralDrugTemplateFormBean, MagistralDrugTemplateFormController } from './MagistralDrugTemplateForm.types';

export const createInitialMedicineRawMaterial = (): MedicineRawMaterialTableBean => ({
   name: '',
   rpw: false,
   excessive: false,
   quantity: 0.01,
   unit: 'GRAMS',
   quantityAbbreviation: null,
});

const defaultValues: MagistralDrugTemplateFormBean = {
   drugName: null,
   drugForm: null,
   additionalDetails: null,
   medicineRawMaterials: [createInitialMedicineRawMaterial()],
};

export const useMagistralDrugTemplateFormController = (
   initialValues?: MagistralDrugTemplateFormBean
): MagistralDrugTemplateFormController => {
   return useFormController<MagistralDrugTemplateFormBean>(
      initialValues
         ? {
              ...initialValues,
              medicineRawMaterials:
                 (initialValues?.medicineRawMaterials?.length ?? 0) > 0
                    ? initialValues?.medicineRawMaterials
                    : defaultValues.medicineRawMaterials,
           }
         : defaultValues
   );
};
